import "./EditScheduleDialog.scss";

import { Alert, Button, Divider, Flex, InfoIcon, Text } from "@fluentui/react-northstar";

type EditScheduleDialogParams = {
  setIsEditSelectionOpen: (open: boolean) => void;
  setIsLimitedEdit?: (limitedEdit: boolean) => void;
  openAuthoring?: (limitedEdit: boolean) => void;
};

export const EditScheduleDialog: React.FC<EditScheduleDialogParams> = ({
  openAuthoring,
  setIsLimitedEdit,
  setIsEditSelectionOpen,
}) => {
  return (
    <>
      <Alert
        className="edit-dialog-alert"
        warning
        content={
          <>
            <Flex gap="gap.small" hAlign="start" vAlign="start">
              <InfoIcon className="edit-dialog-info-icon" size="medium" outline />
              <Text>
                Editing the current instance is{" "}
                <a
                  href="https://www.polly.ai/help/microsoft-teams/editing-a-published-polly"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="brand-link"
                >
                  limited
                </a>
                . All changes made will also be applied to future instances.
                <br />
                <a
                  href="https://www.polly.ai/help/microsoft-teams/editing-a-published-polly"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="brand-link"
                >
                  Learn more
                </a>
              </Text>
            </Flex>
          </>
        }
      />
      <Flex column gap="gap.small">
        <Flex vAlign="center">
          <Text weight="semibold">Edit current instance</Text>
          <Flex.Item push>
            <Button
              className="edit-dialog-button"
              content="Limited edit"
              onClick={() => {
                openAuthoring?.(true);
                setIsLimitedEdit?.(true);
                setIsEditSelectionOpen(false);
              }}
            />
          </Flex.Item>
        </Flex>
        <Divider />
        <Flex vAlign="center">
          <Text weight="semibold">Edit future instances</Text>
          <Flex.Item push>
            <Button
              className="edit-dialog-button"
              content="Full edit"
              onClick={() => {
                openAuthoring?.(false);
                setIsLimitedEdit?.(false);
                setIsEditSelectionOpen(false);
              }}
            />
          </Flex.Item>
        </Flex>
      </Flex>
    </>
  );
};
